import Glide from "@glidejs/glide";

if (document.getElementById("js-glide")) {
  new Glide(".glide", {
    autoplay: 5000,
    animationDuration: 1000,
    animationTimingFunc: "ease",
    perView: 1,
    gap: 0,
    type: "carousel",
  }).mount();
}
